import Phaser from "phaser";

export class ScoreBoard extends Phaser.GameObjects.Container {
  private text: Phaser.GameObjects.Text;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    scene.add.existing(this);

    this.text = scene.add
      .text(0, 0, "0", {
        fontFamily: "Luckiest Guy",
        fontSize: "100px",
        fontStyle: "normal",
        color: "#FF9A00",
        stroke: "#1C120E",
        strokeThickness: 12,
      })
      .setOrigin(0.5);

    this.add(this.text);
  }

  setScore(score: number) {
    this.text.setText(score.toLocaleString());
  }
}
